import React, { ReactNode } from 'react'
import { Modal, Title, Button, Field, Input, Toggle, Spinner } from '../shared'
import { IDraft, DraftModal, IWorkspace } from '../../models'

// tslint:disable:jsx-no-lambda

export class DraftWorkspaceModal extends DraftModal<IWorkspace> {
  protected initialDraft: IDraft<IWorkspace> = {
    isValid: false,
    value: { name: '', trackHours: false }
  }

  constructor(props) {
    super(props)
    this.state = { draft: this.initialDraft }
  }

  private get spinner(): ReactNode {
    if (!this.props.isLoading) return null
    return <Spinner />
  }

  public render(): ReactNode {
    const draft = this.state.draft
    const { title, isHidden, isLoading } = this.props
    return (
      <Modal isHidden={ isHidden } className="draft-workspace-modal">
        <Title label={ title } />
        <div className="fields">
          <Field label="name">
            <Input
              placeholder="name"
              value={ draft.value.name }
              onChange={ x => { this.handleChange({ name: x }) } }
            />
          </Field>
          <Field label="trackHours">
            <Toggle
              isActive={ draft.value.trackHours }
              onChange={ x => { this.handleChange({ trackHours: x }) } }
            />
          </Field>
        </div>
        <div className="buttons">
          <Button label={ title } onClick={ this.handleSubmit } isDisabled={ isLoading } />
          <Button label="cancel" onClick={ this.props.onCancel } isDisabled={ isLoading } />
        </div>
        { this.spinner }
      </Modal>
    )
  }
}
